export enum NotificationContentErrorTypes {
  NotificationContentLoadError,
  NotificationContentPublishError,
  NotificationContentDeleteError,
  NotificationContentPublishNotFoundError,
  NotificationContentDeleteNotFoundError,
  NotificationContentServiceUnavailableError,
}

export class NotificationContentError {
  constructor(public type: NotificationContentErrorTypes, public error: Error) {}
}
